import { all, put, takeLeading } from 'redux-saga/effects'

import ApiSagas from '../api/sagas'
import { services } from '../../graphql'
import { actions } from '..'

export default class InstitutionsSagas {
  static *init() {
    yield
  }

  static *onInstitutionsRequest() {
    const rs = yield* ApiSagas.call(services.declaration.queries.institutions)

    if (!rs.errors && rs.data) {
      yield put(actions.institutions.institutionsSuccess(rs.data))
    } else {
      yield put(actions.institutions.institutionsError(rs.errors))
    }
  }

  static *listeners() {
    yield all([takeLeading(actions.institutions.institutionsRequest, this.onInstitutionsRequest)])
  }
}
